import React, { Component } from "react";
import { ToastContainer, toast } from "react-toastify";
import { producaov2 as api } from "../../services/apis";
import { IS_ADMIN_SET, IS_EMPRESA_SET, setUSER } from "../../services/auth";
import { setUserNode } from "../../services/auth_node";
import { verify_mobile } from "../../utils/Utils";
import "./login.css";
class LoginNode extends Component {
  state = {
    email: "",
    senha_pessoa: "",
    confirma_senha: "",
    nome: "",
    idPessoa: "",
    signup: false,
    showInputs: false,
    changePassword: false,
    code: "",
    verifyCode: false,
    errors: {},
    textoBotao: "ENTRAR",
    message: {
      type: "",
      msg: "",
    },
  };

  // ---- Get Input Values ----
  handleLoginInput = (e) => {
    if (e.target.value !== "") {
      this.setState({
        [e.target.name]: e.target.value,
      });
      return;
    }
    this.setState({
      [e.target.name]: "",
    });
  };

  // ---- End Input Values ----

  // ---- Basic Validation ----
  validation = (isSignUp) => {
    const {
      nome,
      email,
      confirma_senha,
      senha_pessoa,
      showInputs,
    } = this.state;
    const validSenha = (() => {
      if (senha_pessoa !== confirma_senha && showInputs)
        return "Suas senhas não coincidem ";

      if (senha_pessoa.length <= 5)
        return "O comprimento da senha deve ser maior que 5 caracteres";

      return false;
    })();

    const validName =
      nome.length < 3 && "O comprimento do seu nome não é valido";

    const validEmail = (() => {
      return false;
    })();
    if (isSignUp) {
      return validName || validSenha || validEmail
        ? { email: validEmail, senha: validSenha, nome: validName }
        : false;
    }
    return validName || validSenha || validEmail
      ? { email: validEmail, senha: validSenha }
      : false;
  };

  handleSubmitLogin = async () => /*e*/ {
    const { showInputs, code, verifyCode } = this.state;
    const isValid = this.validation(showInputs);

    if (verifyCode && code.length > 3) {
      this.handleChangePassword();
      return;
    }

    if (code.length > 3 && !showInputs) {
      this.handleVerifyCode();
      return;
    }

    if ((isValid && isValid.nome) || isValid.email || isValid.senha) {
      this.setState({ errors: isValid, confirma_senha: "" });
      return;
    }

    if (!showInputs) {
      this.handleSignIn();
      return;
    }
    this.handleSignUp();
    return;
  };
  // ---- End OnSubmit Form -----

  handleAlertMessage = (type, msg, time = 0) => {
    window.scrollTo({
      behavior: "smooth",
      top: document.querySelector("#container").offsetTop - 40,
    });

    if (time > 0) {
      this.setState({
        message: {
          type: type,
          msg: msg,
        },
      });
      setTimeout(() => {
        this.setState({
          message: {
            type: "",
            msg: "",
          },
        });
      }, time);
      return;
    }
    this.setState({
      message: {
        type: type,
        msg: msg,
      },
    });
  };

  // ---- Login ----
  handleSignIn = async () => {
    const { email, senha_pessoa } = this.state;

    let response;
    try {
      response = await api.post("/auth-session", {
        email,
        senha_pessoa,
      });
    } catch (err) {
      this.setState({
        nome: "",
        senha_pessoa: "",
        confirma_senha: "",
      });
      if (err.response) {
        if (err.response.data.message.err === "forceChange") {
          this.handleAlertMessage(
            "Atenção",
            "Enviamos um código de redefinição de senha para seu email, por favor, insira o código acima"
          );
          this.setState({
            changePassword: true,
            idPessoa: err.response.data.message.pessoa,
          });

          return;
        }
      }
      this.setState({
        errors: {
          senha: "Senha ou email não conferem!",
        },
      });
      return;
    }

    if (response.data) {
      localStorage.setItem("oauth_token", response.data.token);
      localStorage.setItem("refresh_token", response.data.refresh);

      const user = response.data.pessoa;

      setUserNode({
        id: user.id,
        nome: user.nome,
        email: user.email,
        foto: user.foto,
        premium: user.premium,
        is_premium: user.premium,
        gestorEmpresa: user.gestorEmpresa,
        alunoEmpresa: user.alunoEmpresa,
        aluno_empresa: user.alunoEmpresa,
        empresa: user.empresa,
        admin: user.admin,
      });

      localStorage.setItem("Token", user.token);
      setUSER({
        // logando também no user 'antigo' para garantir o painel corporativo
        id: user.id,
        nome: user.nome,
        email: user.email,
        foto: user.foto,
        premium: user.premium,
        is_premium: user.premium,
        gestorEmpresa: user.gestorEmpresa,
        alunoEmpresa: user.alunoEmpresa,
        aluno_empresa: user.alunoEmpresa,
        empresa: user.empresa,
        admin: user.admin,
      });

      IS_ADMIN_SET(user.admin);

      IS_EMPRESA_SET(user.gestorEmpresa);

      if (user.gestorEmpresa) {
        localStorage.setItem("redirect", `/painelempresa/${user.empresa.url}`);
      }

      if (
        user.empresa &&
        user.empresa !== null &&
        user.alunoEmpresa &&
        user.empresa.id !== 10705
      ) {
        localStorage.setItem("redirect", `/universidade/${user.empresa.url}`);
      }

      let storageRedirect = localStorage.getItem("redirect");
      const redirect = storageRedirect;

      if (redirect) {
        localStorage.removeItem("redirect");
        window.location.href = `${redirect}`;
      } else {
        window.location.href = "/";
      }

      return;
    }
  };

  handleChangePassword = async () => {
    const { code, senha_pessoa } = this.state;
    const validation = this.validation(true);
    const { senha } = validation;
    if (senha) {
      this.setState({ errors: senha });
      return;
    }
    try {
      await api.put("/pessoa/alterasenha", {
        code,
        senha_pessoa,
      });
      this.handleAlertMessage(
        "sucesso",
        "Senha alterada com sucesso, por gentileza, realize o login normalmente!",
        5000
      );
      this.setState({
        senha_pessoa: "",
        confirma_senha: "",
        code: "",
        verifyCode: false,
        changePassword: false,
      });
    } catch (err) {
      if (err.response.data) {
        this.handleAlertMessage("error", err.response.data.err, 5000);
        return;
      }
      this.handleAlertMessage(
        "error",
        "Confira seus dados e tente novamente",
        5000
      );
      return;
    }
  };
  // ---- End Login ----

  // ---- Register ----
  handleSignUp = async () => {
    const { nome, email, senha_pessoa } = this.state;
    this.setState({
      code: "",
      verifyCode: false,
      changePassword: false,
    });
    if (nome) {
      const nameWithoutFinalSpace = nome.trimEnd();
      const splitNome = nameWithoutFinalSpace.split(" ");
      if (splitNome.length < 2) {
        this.handleAlertMessage(
          "error",
          "Por gentileza preencha seu nome completo."
          // 5000
        );
        return;
      }
    }

    try {
      const response = await api.post("/signup", {
        nome,
        email,
        senha_pessoa,
      });
      this.handleSignUpForm(false);

      this.setState({
        nome: "",
        email: "",
        senha_pessoa: "",
        confirma_senha: "",
      });

      if (response.data.token) {
        localStorage.setItem("oauth_token", response.data.token);
        localStorage.setItem("refresh_token", response.data.refresh);
        const user = response.data.pessoa;

        setUserNode({
          id: user.id,
          nome: user.nome,
          email: user.email,
          foto: user.foto,
          token: user.token,
        });

        localStorage.setItem("Token", user.token);
        setUSER({
          // logando também no user 'antigo' para garantir o painel corporativo
          id: user.id,
          nome: user.nome,
          email: user.email,
          foto: user.foto,
          token: user.token,
        });
        IS_ADMIN_SET(false);
        IS_EMPRESA_SET(false);

        // setTimeout(() => {
        //   this.handleAlertMessage(
        //     "sucesso",
        //     "Você foi cadastrado com sucesso!",
        //     1000
        //   );
        // },1000)

        let storageRedirect = localStorage.getItem("redirect");
        const redirect = storageRedirect;
        setTimeout(() => {
          if (redirect) {
            localStorage.removeItem("redirect");
            window.location.href = `${redirect}`;
          } else {
            window.location.href = "/";
          }
        }, 200);

        return;
      }

      this.handleAlertMessage(
        "error",
        "Ocorreu um erro, confira seus dados e tente novamente!",
        5000
      );
      return;
    } catch (err) {
      this.handleAlertMessage(
        "error",
        "Confira seus dados e tente novamente!",
        5000
      );
      return;
    }
  };
  // ---- End Register ----

  handleVerifyCode = async () => {
    const { code, idPessoa } = this.state;
    try {
      await api.put("/pessoa/codigo", {
        code,
        idPessoa,
      });
      this.setState({ verifyCode: true, textoBotao: "Redefinir senha" });
      this.handleAlertMessage("sucesso", "Digite sua nova senha!");
    } catch (err) {
      if (err.response.data) {
        toast.error(err.response.data.err);
        this.handleAlertMessage("error", err.response.data.err, 5000);
        return;
      }
      this.handleAlertMessage(
        "error",
        "Código inválido, verifique o código e tente novamente!",
        5000
      );
      this.setState({ verifyCode: false });
      return;
    }
  };

  lostMyPassword = async () => {
    this.setState({ errors: {} });
    const { email } = this.state;
    if (!email) {
      this.setState({
        errors: { email: "preencha seu email, para redefinirmos sua senha" },
      });
      return;
    }
    try {
      const response = await api.post("/lostmypassword", {
        email,
      });
      this.handleAlertMessage(
        "atencao",
        "Enviamos um código para seu email de redefinição de senha, por gentileza, insira o mesmo acima"
      );
      this.setState({
        changePassword: true,
        idPessoa: response.data.pessoa,
      });
    } catch (err) {
      this.handleAlertMessage(
        "atencao",
        "Não conseguimos achar um usuário a apartir do email fornecido, tente novamente."
      );
    }
  };

  // ---- Render SignUp Form ----
  handleSignUpForm = (input, botao = "Entrar") => {
    this.setState({
      signup: true,
      showInputs: !input,
      errors: {},
      textoBotao: botao,
    });
    setTimeout(() => {
      this.setState({ signup: false, showInputs: input, errors: {} });
    }, 1000);
  };
  // ---- End SignUp Form ----

  componentDidMount() {
    if (window.location.href.indexOf("cadastro") > -1) {
      this.handleSignUpForm(true, "Cadastrar");
    }
  }

  render() {
    const {
      senha_pessoa,
      email,
      signup,
      showInputs,
      confirma_senha,
      nome,
      errors,
      changePassword,
      code,
      message,
      verifyCode,
      textoBotao,
    } = this.state;
    return (
      <>
        <style>
          {`body{
          background-color: #f5f1f1;
          height:  "100vh"}
          
        }`}
        </style>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            height: "100vh",
          }}
          id="container"
        >
          <div
            className="containerLoginNode styleLoginNode"
            style={{
              animation: signup
                ? "fadeOut 0.5s ease-in both"
                : "fadeIn 0.5s ease-in both",
              display: "flex",
              justifyCOntent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <form
              // onSubmit={e => {
              //   this.handleSubmitLogin(e);
              // }}
              className={verify_mobile() ? "formLoginNodeMob" : "formLoginNode"}
              style={{
                height: !signup && showInputs && "92%",
              }}
            >
              <div className="frmSpace">
                <div className="headerFormLoginNode">
                  {verify_mobile() ? (
                    <img
                      className="imageVoittoLoginNodeMob"
                      src="https://files.voitto.com.br/logo-completo.jpeg"
                      alt=""
                    />
                  ) : (
                    <img
                      className="imageVoittoLoginNode"
                      src="https://files.voitto.com.br/logo-completo.jpeg"
                      alt=""
                    />
                  )}
                </div>
                <ToastContainer style={{ color: "#fff" }} autoClose={3000} />

                {!changePassword ? (
                  <div>
                    {showInputs && (
                      <div
                        className="field"
                        style={{
                          marginTop: "15px",
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      >
                        <div
                          className="ui left labeled input"
                          style={{
                            width: verify_mobile() ? "120%" : "100%",
                            marginLeft: verify_mobile() ? "-5.3%" : null,
                            marginRight: verify_mobile() ? "-6%" : null,
                          }}
                        >
                          <label className="ui label">
                            <i className="user icon"></i>{" "}
                          </label>
                          <input
                            required
                            minLength="3"
                            type="text"
                            name="nome"
                            autoFocus={showInputs && true}
                            autoComplete="off"
                            value={nome}
                            onChange={(e) => this.handleLoginInput(e)}
                            placeholder="Seu Nome Completo"
                          />
                        </div>
                        <small className="labelError">
                          {errors.nome !== "" && errors.nome}
                        </small>
                      </div>
                    )}

                    <div
                      className="field"
                      style={{
                        marginTop: "15px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                      }}
                    >
                      <div
                        className="ui left labeled input"
                        style={{
                          width: verify_mobile() ? "112%" : "100%",
                          marginLeft: verify_mobile() ? "-5.3%" : null,
                        }}
                      >
                        <label className="ui label">
                          <i
                            style={{ left: "7px", position: "relative" }}
                            className="envelope icon"
                          ></i>
                        </label>
                        <input
                          required
                          minLength="7"
                          type="email"
                          name="email"
                          autoFocus={!showInputs && true}
                          value={email}
                          autoComplete="off"
                          onChange={(e) => this.handleLoginInput(e)}
                          placeholder="alunovoitto@email.com.br"
                        />
                      </div>
                      <small className="labelError">
                        {errors.email !== "" && errors.email}
                      </small>
                    </div>
                    <div
                      className="field"
                      style={{
                        marginTop: "15px",
                        display: "flex",
                        justifyContent: "flex-start",
                      }}
                    >
                      <div
                        className="ui left labeled input"
                        style={{
                          width: verify_mobile() ? "112%" : "100%",
                          marginLeft: verify_mobile() ? "-5.3%" : null,
                          marginRight: verify_mobile() ? "-7%" : null,
                        }}
                      >
                        <label className="ui label">
                          <i
                            style={{
                              width: "14px",
                              left: "7px",
                              position: "relative",
                            }}
                            className="lock icon"
                          ></i>{" "}
                        </label>
                        <input
                          required
                          type="password"
                          minLength={(changePassword || signup) && "7"}
                          name="senha_pessoa"
                          value={senha_pessoa}
                          onChange={(e) => this.handleLoginInput(e)}
                          placeholder="Sua senha"
                        />
                      </div>
                    </div>
                    <small className="labelError">
                      {errors.senha !== "" && errors.senha}
                    </small>
                    {showInputs && (
                      <div
                        className="field"
                        style={{
                          marginTop: "15px",
                          display: "flex",
                          justifyContent: "flex-start",
                        }}
                      >
                        <div
                          className="ui left labeled input"
                          style={{
                            width: verify_mobile() ? "120%" : "100%",
                            marginLeft: verify_mobile() ? "-5.3%" : null,
                            marginRight: verify_mobile() ? "-6%" : null,
                          }}
                        >
                          <label className="ui label">
                            <i
                              style={{
                                width: "14px",
                                left: "7px",
                                position: "relative",
                              }}
                              className="lock icon"
                            ></i>{" "}
                          </label>
                          <input
                            required
                            type="password"
                            minLength="7"
                            className="senha"
                            name="confirma_senha"
                            value={confirma_senha}
                            onChange={(e) => this.handleLoginInput(e)}
                            placeholder="Repita sua senha"
                          />
                        </div>
                      </div>
                    )}
                  </div>
                ) : !verifyCode ? (
                  <div className="groupLoginNode">
                    <input
                      onChange={(e) => this.handleLoginInput(e)}
                      className="inputLoginNode"
                      name="code"
                      type="text"
                      autoFocus={showInputs && true}
                      autoComplete="off"
                      value={code}
                    />
                    <span className="bar"></span>
                    <label className="labelLogin">
                      {code === "" && "Codigo"}
                    </label>
                  </div>
                ) : (
                  <div>
                    <div className="groupLoginNode">
                      <input
                        onChange={(e) => this.handleLoginInput(e)}
                        className="inputLoginNode"
                        name="senha_pessoa"
                        type="password"
                      />
                      <span className="bar"></span>
                      <label className="labelLogin">
                        {senha_pessoa === "" && "Senha"}
                      </label>
                      <small className="labelError">
                        {errors.senha !== "" && errors.senha}
                      </small>
                    </div>
                    <div className="groupLoginNode">
                      <input
                        onChange={(e) => this.handleLoginInput(e)}
                        className="inputLoginConfirmNode"
                        name="confirma_senha"
                        type="password"
                        value={confirma_senha}
                      />
                      <span className="bar"></span>
                      <label className="labelLogin">
                        {confirma_senha === "" && "Repita sua senha"}
                      </label>
                    </div>
                  </div>
                )}

                <div className="lostMyPassword">
                  <div>
                    <b
                      style={{
                        cursor: "pointer",
                        marginRight: verify_mobile() ? null : 6,
                        fontSize: verify_mobile() ? "120%" : null,
                      }}
                      onClick={() => {
                        this.lostMyPassword();
                      }}
                    >
                      <a className="anchorHrefLoginNode">
                        Esqueci minha senha!
                      </a>
                    </b>
                  </div>

                  <div>
                    {!showInputs ? (
                      <p style={{ fontSize: verify_mobile() ? "121%" : null }}>
                        Não tem uma conta?
                        <a
                          className="anchorHrefLoginNode"
                          onClick={() =>
                            this.handleSignUpForm(true, "Cadastrar")
                          }
                        >
                          Cadastre-se
                        </a>
                      </p>
                    ) : (
                      <p>
                        Já possui cadastro?
                        <a
                          className="anchorHrefLoginNode"
                          onClick={() => this.handleSignUpForm(false)}
                        >
                          Faça Login
                        </a>
                      </p>
                    )}
                  </div>
                </div>
                <div></div>
              </div>

              {message.msg !== "" && (
                <div
                  style={{
                    marginLeft: verify_mobile() ? null : 12,
                    marginRight: verify_mobile() ? null : 12,
                  }}
                  class={`alerta ${message.type}`}
                >
                  {message.msg}
                </div>
              )}
              <div
                onClick={() => this.handleSubmitLogin()}
                // type="submit"
                style={{
                  fontFamily: "Montserrat",
                  fontWeight: "700",
                  backgroundColor: "orangered",
                  color: "white",
                  height: "70px",
                  marginTop: "10px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                id="cadastrarBtnMaster"
                className="fluid ui big submit button"
              >
                {textoBotao}{" "}
                {textoBotao === "ENTRAR" ? (
                  <i
                    style={{ marginLeft: 0 }}
                    class="angle double right icon"
                  ></i>
                ) : null}
                <div className="ripples buttonRipples">
                  <span className="ripplesCircle"></span>
                </div>
              </div>
            </form>
          </div>
        </div>
      </>
    );
  }
}
export default LoginNode;
